import { Alert, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { IconFlagFilled } from "@tabler/icons-react";
import MxDetailSmallCard from "@rf-l1/page/details/MxDetailCardSmall";
import { usePropertyDetailPage } from "../../context/PropertyDetailPageContext";
import useUserHasPermission from "@/shared/hooks/use-useris.hook";

/**
 * PropertyWarningsCard
 *
 * Tarjeta que muestra avisos importantes de la propiedad.
 * Solo visible para Super Admins cuando la propiedad tiene alertas importantes.
 *
 * @component
 *
 * Reglas de negocio:
 * - Solo se muestra si `hasImportantAlert` es true
 * - Solo visible para usuarios con rol SUPER_ADMIN
 * - Muestra el mensaje de alerta con un ícono de bandera roja
 */
const PropertyWarningsCard = () => {
  const { hasImportantAlert, importantAlertMessage } = usePropertyDetailPage();
  const { USER_ROLE } = useUserHasPermission();

  // No mostrar si no hay alerta importante
  if (!hasImportantAlert) {
    return null;
  }

  // Solo mostrar para Super Admins
  if (!USER_ROLE.SUPER_ADMIN) {
    return null;
  }

  return (
    <MxDetailSmallCard title="Avisos">
      <ContentWrapper>
        <Alert icon={<StyledIconFlag />} severity="error">
          {importantAlertMessage}
        </Alert>
      </ContentWrapper>
    </MxDetailSmallCard>
  );
};

export default PropertyWarningsCard;

const ContentWrapper = styled(Box)(({ theme }) => ({
  width: "100%"
}));

const StyledIconFlag = styled(IconFlagFilled)(({ theme }) => ({
  fill: theme.palette.error.main,
  width: "18px",
  height: "18px"
}));
